import _ from 'underscore';
import getLevel from '../util/get-level';
import PerformanceMetricsColumns from '../common-columns/performance-metrics-columns';

export function getName() {
  return 'audience_associations_level';
}

export function getColumnsMetadata() {
  return _.defaults({
    AudienceId: 'AudienceCriterion/AudienceId',
    AudienceName: 'AudienceCriterion/AudienceName',
    AudienceType: 'AudienceCriterion/AudienceType',
    BidMultiplier: 'AudienceCriterion/BidMultiplier',
    Campaign: 'Campaign/Name',
    AdGroup: 'AdGroup/Name',
    Level: 'Level',
    TotalEffectiveCost: 'PerformanceMetrics/Spend',
    CashbackPercent: 'AudienceCriterion/CashbackAdjustment',
  }, _.omit(PerformanceMetricsColumns, 'Spend'));
}

export function getRoute({
  CampaignId,
  AdGroupId,
}) {
  const level = getLevel({
    CampaignId,
    AdGroupId,
  });

  switch (level) {
    case 'AdGroup':
      return 'customer/:customer_id/account/:account_id/campaign/:campaign_id/adgroup/:adgroup_id/audiences';
    case 'Campaign':
      return 'customer/:customer_id/account/:account_id/campaign/:campaign_id/audiences';
    case 'Account':
    default:
      return 'customer/:customer_id/account/:account_id/audiences';
  }
}
